import type { QueryKeyReturnType } from '@inflearn/codegen-wrapper';

import {
  API_ENDPOINT,
  useClientApiV1CoursesIdSimpleQuery,
} from '../../resources/@types/courseSchema';

interface UseClientV1CoursesIdSimpleQuery {
  courseId: number;
  options?: Parameters<typeof useClientApiV1CoursesIdSimpleQuery>[0]['options'];
}

export function useCoursesIdSimpleQuery({ courseId, options }: UseClientV1CoursesIdSimpleQuery) {
  return useClientApiV1CoursesIdSimpleQuery({
    queryKey: getCoursesIdSimpleQueryKey(courseId),
    url: API_ENDPOINT.CLIENT_V1_COURSES_ID_SIMPLE(String(courseId)),
    options,
  });
}

export const getCoursesIdSimpleQueryKey = (courseId: number): QueryKeyReturnType => [
  API_ENDPOINT.CLIENT_V1_COURSES_ID_SIMPLE(String(courseId)),
];
